import { toast } from "./toast";

/**
 * In-session "couldn't refresh balances" toast. The splash keeps the last-known
 * balances and the next poll heals them; this is the visible signal that a
 * refresh failed. Module-scoped timestamp throttles to one toast per window so
 * the multiple useBalances instances (splash + dashboard + accounts) can't
 * stack toasts, and a persistent poll failure re-toasts at most once per window.
 *
 * `now` is injectable for unit tests; production passes the default Date.now().
 */
const THROTTLE_MS = 30_000;
let lastShownAt = Number.NEGATIVE_INFINITY;

export function notifyBalancesStale(
  message: string,
  now: number = Date.now()
): void {
  if (now - lastShownAt < THROTTLE_MS) return;
  lastShownAt = now;
  toast.warning(message);
}
